import { gql } from '@apollo/client';

export const AssignmentFragment = gql`
  fragment Assignment on Assignment {
    id: _id
    name
    expirationDate
    timeLimit
    expired
    maxScore

    answered
    exercises {
      id: _id
      text
      type
      code
      explanation
      media
      questions
    }

    answer
    showOnlyTotalScore
    allowAnswersAfterTimeLimit
  }
`;
